import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogTitle,
  FormControl,
  DialogContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  Box,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Label } from 'reactstrap';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import { ReactComponent as Dashboard } from '../../media/dashboard2.svg';
import { ReactComponent as Ops } from '../../media/opsss.svg';
import { ReactComponent as ManageIcon } from '../../media/obm.svg';
import { ReactComponent as MastersIcon } from '../../media/pd.svg';
import { ReactComponent as ReportsIcon } from '../../media/prrd.svg';
import './UserPrivileges.css';
import './animation.css';

const SwitchContainer = ({ children }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={2}
    py={2}
    px={2}
    mb={2}
    elevation={3}
    component={Paper}
    sx={{ backgroundColor: 'inherit ' }}
  >
    {children}
  </Stack>
);

const iconMap = {
  Dashboard: <Dashboard style={{ color: 'white', width: 24, height: 24 }} />,
  Masters: <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />,
  Transactions: <ManageIcon style={{ color: 'white', width: 24, height: 24 }} />,
  Reports: <ReportsIcon style={{ color: 'white', width: 24, height: 24 }} />,
}

const UserPrivileges = () => {

  const [searchTerm, setSearchTerm] = useState('');
  const [expanded, setExpanded] = React.useState({});
  const [dialogOpenPicker, setDialogOpenPicker] = useState(false);
  const [UserId, setUserId] = useState(null);

  // control fields states values
  const [usersData, setusersData] = useState([]);
  const [filteredUsersData, setfilteredUsersData] = useState([]);
  const [data, setData] = useState([]);
  const [userSelected, setuserSelected] = useState(null);
  const [userAccessScreens, setUserAcessScreens] = useState([])


  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // API Integration
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllScreens()
    getUsers();
  }, []);

  const getAllScreens = async () => {
    try {
      const res = await axios.get('Master/UserPrivileges/GetAllScreens');
      const modifiedData = res.data.reduce((acc, item) => {
        if (!acc[item.Type]) {
          acc[item.Type] = []
        };
        acc[item.Type].push(item)
        return acc;
      }, {})
      setData(modifiedData)
      resetExpand(modifiedData)
    }
    catch (error) {
      console.error('Error fetching Screens:', error.data?.message || error.message);
    }
  }

  // get all Users Request
  const getUsers = async () => {
    showLoading();
    try {
      const res = await axios.get('Master/User/GetAllActiveUser');
      setusersData(res.data);
      setfilteredUsersData(res.data);
    } catch (error) {
      console.error('Error fetching courses:', error.data?.message || error.message);
      openSnackBar(error.data?.message || error.message || 'Something went wrong!', 'error');
    }
    hideLoading();
  };

  const handleUserSelect = async (user) => {
    showLoading();
    try {
      handleDialogClosePicker(false);
      setuserSelected(user);

      const res = await axios.post(`Master/UserPrivileges/GetOneUserPrivilege`, { UserId: user.UserID });
      const userAccess = res.data.reduce((acc, item) => {
        if (!acc[item.Type]) acc[item.Type] = [];
        acc[item.Type].push(Number(item.ScreenId))
        return acc;
      }, {})
      resetExpand(data)
      setUserAcessScreens(userAccess)

    } catch (error) {
      openSnackBar(error.data?.message || error.message || 'Something went wrong!', 'error');
      console.error('Error fetching data:', error);
    }
    hideLoading();
  };

  const DeleteAndInsertAccess = async () => {
    showLoading();
    try {
      const userScreenIds = Object.values(userAccessScreens).flatMap(val => val)
      console.log("User Screens", userScreenIds)
      await axios.delete(`Master/UserPrivileges/DeleteAllUserPrivilege/${userSelected.UserID}`);
      await axios.post('Master/UserPrivileges/InsertUserPrivilege', {
        AccessScreens: userScreenIds,
        UserId: userSelected.UserID,
        CreatedBy: UserId,
      });
      setuserSelected(null);
      openSnackBar('Access updated successfully!', 'success');
    } catch (error) {
      openSnackBar(error.data?.message || error.message || 'Something went wrong!', 'error');
      console.error('Error deleting access:', error);
    }
    hideLoading();
  };
  const handleDialogClosePicker = () => {
    setDialogOpenPicker(false);
    setSearchTerm('');
  };

  const resetExpand = (data) => {
    const newExpanded = {};
    Object.keys(data).forEach(key => {
      newExpanded[key] = true
    })
    setExpanded(newExpanded)
  }

  const handleExpansion = (type) => {
    const updatedExpanded = { ...expanded }
    updatedExpanded[type] = !updatedExpanded[type]
    setExpanded(updatedExpanded);
  };


  const enableAllInCategory = (type, event) => {
    const updatedUserAccessScreens = { ...userAccessScreens }
    updatedUserAccessScreens[type] = event.target.checked ? [...(data[type]?.map(screens => Number(screens.ScreenId)) || [])] : []
    setUserAcessScreens(updatedUserAccessScreens);
  };

  const handleUserDataFilter = (e) => {
    const newUserData = usersData.filter((user) =>
      `${user.LoginCode} ${user.LoginName} ${user.Designation} ${user.EmailId}`
        .toLowerCase()
        .includes(e.target.value?.toLowerCase())
    );
    setSearchTerm(e.target.value);
    setfilteredUsersData(newUserData);
  };

  const handleChange = (row) => {
    const ScreenId = Number(row.ScreenId);
    const newUserAccessScreens = { ...userAccessScreens }
    if (userAccessScreens[row.Type]?.includes(ScreenId)) {
      const updatedType = newUserAccessScreens[row.Type].filter(screenid => screenid !== ScreenId)
      newUserAccessScreens[row.Type] = updatedType;
      setUserAcessScreens(newUserAccessScreens);
    } else {
      if (!newUserAccessScreens[row.Type]) newUserAccessScreens[row.Type] = []
      newUserAccessScreens[row.Type].push(ScreenId);
      setUserAcessScreens(newUserAccessScreens)
    }
  }
  return (
    <>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              User Privileges
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
          {userSelected !== null && (
            <Grid item md={12}>
              <Paper elevation={7} sx={{ p: 2, background: 'initial' }}>
                <Typography variant="h5" color="#607d8b" textAlign={'left'} borderBottom={1} pb={1} mx={2}>
                  User Details
                </Typography>

                <Grid
                  container
                  justifyContent={'center'}
                  alignItems={'center'}
                  p={2}
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        User Code :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.LoginCode}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        User Name :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.LoginName}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                        Designation :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.Designation}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        Email :
                      </Typography>
                      <Typography variant="h6" color="#009688" textTransform={'lowercase'}>
                        {userSelected?.EmailId}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button
              variant={userSelected === '' ? 'contained' : 'outlined'}
              color={userSelected === '' ? 'warning' : 'primary'}
              fullWidth
              onClick={(e) => {
                setDialogOpenPicker(true);
                setfilteredUsersData(usersData);
              }}
            >
              {userSelected === null ? 'Select User to Proceed' : 'Change User'}
            </Button>
          </Grid>
          {userSelected !== null && (
            <>

              {
                Object.entries(data).map(([type, screens]) => (
                  <Grid item xs={12}>
                    <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                      <Accordion
                        expanded={expanded[type]}
                        disableGutters
                        sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={() => handleExpansion(type)} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          sx={{ borderTop: 'none' }}
                        >
                          <Stack
                            justifyContent={'space-between'}
                            direction={'row'}
                            alignItems={'center'}
                            p={0}
                            m={0}
                            pr={2}
                            width={'100%'}
                          >
                            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                              <IconButton aria-label="ExpandMoreIcon" color="white">
                                {iconMap[type] || <Dashboard style={{ color: 'white', width: 24, height: 24 }} />}
                              </IconButton>
                              <Typography
                                sx={{
                                  color: '#36BA98',
                                  '&.active': {
                                    color: 'text.primary',
                                    bgcolor: 'action.selected',
                                    fontWeight: 'fontWeightBold',
                                  },
                                }}
                                variant="h6"
                              >
                                {type}
                              </Typography>
                            </Stack>

                            <Switch
                              checked={screens?.length === userAccessScreens[type]?.length}
                              onChange={(event) => enableAllInCategory(type, event)}
                              inputProps={{ 'aria-label': 'controlled' }}
                              color="secondary"
                              size="small"
                              sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: '#36BA98',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: '#C1D8C3',
                                },
                              }}
                            />
                          </Stack>
                        </AccordionSummary>

                        <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                          <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                            {screens.map((row, index) => (
                              <Grid key={index} item xs={4}>
                                <SwitchContainer>
                                  <Box display="flex" alignItems="center" gap={1}>
                                    <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                      {row.ScreenName}

                                    </Label>
                                    {(row.IsMobile === 'Y') && <PhoneAndroidIcon sx={{ fontSize: 22 }} />}
                                  </Box>

                                  <input
                                    id={`OutstandingSummary_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={userAccessScreens[type]?.includes(Number(row.ScreenId)) || false}
                                    onClick={(e) => handleChange(row)}
                                  />
                                </SwitchContainer>
                              </Grid>
                            ))}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Stack>
                  </Grid>
                ))
              }
              <Grid item xs={12}>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} my={2}>
                  <Button
                    variant="contained"
                    color="success"
                    sx={{ boxShadow: 1, backgroundColor: '#36BA98', color: 'white' }}
                    onClick={DeleteAndInsertAccess}
                  >
                    Save
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Grid>
      </Container>

      <Dialog open={dialogOpenPicker} onClose={handleDialogClosePicker} maxWidth="md" fullWidth>
        <DialogTitle>Select User to Control </DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={handleUserDataFilter}
                value={searchTerm}
              />
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="left">User Code</TableCell>
                  <TableCell align="left">User Name</TableCell>
                  <TableCell align="left">Designation</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsersData.map((user, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    {/* <TableCell align="center">{user.SNo}</TableCell> */}
                    <TableCell align="left">{user.LoginCode}</TableCell>
                    <TableCell align="left">{user.LoginName}</TableCell>
                    <TableCell align="left">{user.Designation}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          handleUserSelect(user);
                        }}
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserPrivileges;
